export enum ReferralActionTypes {
  SET_REFERRAL = 'SET_REFERRAL',
}

export interface IReferral {
  readonly code: string
  readonly referrals: number
}
